import { Route } from "@angular/router";
import { AuthGuard } from "app/core/auth/guards/auth.guard";
import { NoAuthGuard } from "app/core/auth/guards/noAuth.guard";
import { LayoutComponent } from "app/layout/layout.component";
import { InitialDataResolver } from "app/app.resolvers";
import { AuthSignInComponent } from "./modules/auth/sign-in/sign-in.component";
import { AppAuthGuardService } from "@bundle/service/app-auth-guard.service";

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "page/profile/profile",
  },
  {
    path: "",
    pathMatch: "full",
    redirectTo: "page/profile/profile",
  },
  {
    path: "",
    // canMatch: [NoAuthGuard],
    // pathMatch: 'full',
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "confirmation-required",
        loadChildren: () =>
          import("app/modules/auth/confirmation-required/confirmation-required.module").then(
            (m) => m.AuthConfirmationRequiredModule,
          ),
      },
      {
        path: "forgot-password",
        loadChildren: () =>
          import("app/modules/auth/forgot-password/forgot-password.module").then(
            (m) => m.AuthForgotPasswordModule,
          ),
      },
      {
        path: "reset-password",
        loadChildren: () =>
          import("app/modules/auth/reset-password/reset-password.module").then(
            (m) => m.AuthResetPasswordModule,
          ),
      },
      {
        path: "sign-in",
        loadChildren: () =>
          import("app/modules/auth/sign-in/sign-in.module").then(
            (m) => m.AuthSignInModule,
          ),
      },
      {
        path: "sign-up",
        loadChildren: () =>
          import("app/modules/auth/sign-up/sign-up.module").then(
            (m) => m.AuthSignUpModule,
          ),
      },
      {
        path: "validation",
        loadChildren: () =>
          import("app/modules/validation/docs-validation/docs-validation.module").then(
            (m) => m.DocsValidationModule,
          ),
      },
    ],
  },
  {
    path: "",
    // canMatch: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "sign-out",
        loadChildren: () =>
          import("app/modules/auth/sign-out/sign-out.module").then(
            (m) => m.AuthSignOutModule,
          ),
      },
      {
        path: "unlock-session",
        loadChildren: () =>
          import("app/modules/auth/unlock-session/unlock-session.module").then(
            (m) => m.AuthUnlockSessionModule,
          ),
      },
    ],
  },
  {
    path: "",
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "home",
        loadChildren: () =>
          import("app/modules/landing/home/home.module").then(
            (m) => m.LandingHomeModule,
          ),
      },
    ],
  },
  {
    path: "",
    canActivateChild: [AuthGuard],
    // canMatch: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: InitialDataResolver,
    },
    children: [
      {
        path: "example",
        loadChildren: () =>
          import("app/modules/admin/example/example.module").then(
            (m) => m.ExampleModule,
          ),
      },
      {
        path: "page",
        loadChildren: () =>
          import("./page/page.module").then((m) => m.PageModule),
      },
    ],
  },
  {
    path: "**",
    // canMatch: [AuthGuard],
    canActivateChild: [AuthGuard],
    pathMatch: "full",
    redirectTo: "page/profile/profile",
  },
];
